import { render, staticRenderFns } from "./CreateAssignmentForm.vue?vue&type=template&id=3871a7a6&"
import script from "./CreateAssignmentForm.vue?vue&type=script&lang=js&"
export * from "./CreateAssignmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports